// eslint-disable-next-line no-restricted-imports
import Link from 'next/link'
import { PropsWithChildren } from 'react'

interface LinkWrapperProps {
  className?: string
  id?: string
  href: string
  target?: string
  onClick?: () => void
  ariaHasPopup?: boolean
  ariaExpanded?: boolean
  ariaControls?: string
  ariaLabel?: string
  tabIndex?: number
}

const LinkWrapper = ({
  children,
  className,
  id,
  href,
  target,
  onClick,
  ariaHasPopup,
  ariaExpanded,
  ariaControls,
  ariaLabel,
  tabIndex
}: PropsWithChildren<LinkWrapperProps>) => {
  /*
   * Os atributos de acessibilidade sao os mesmos nos dois ramos, entao vivem num
   * objeto unico em vez de repetidos em cada elemento.
   */
  const anchorProps = {
    'aria-haspopup': ariaHasPopup,
    'aria-expanded': ariaExpanded,
    'aria-controls': ariaControls,
    'aria-label': ariaLabel,
    tabIndex
  }

  const isInternalLink = href.startsWith('/')
  if (isInternalLink) {
    return (
      // eslint-disable-next-line @alice-health/w-link
      <Link
        id={id}
        data-testid={id ? `${id}-internal` : undefined}
        className={className}
        href={href}
        passHref
        target={target}
        onClick={onClick}
        {...anchorProps}
      >
        {children}
      </Link>
    )
  }

  return (
    // eslint-disable-next-line react/forbid-elements, @alice-health/w-link
    <a
      id={id}
      data-testid={id ? `${id}-external` : undefined}
      className={className}
      href={href}
      target={target}
      onClick={onClick}
      {...anchorProps}
    >
      {children}
    </a>
  )
}

export { LinkWrapper }
